import RxGoogleMap from '../map/RxGoogleMap';

const layers = [
  { id: 'corn-nitrogen-rx', name: 'Corn Nitrogen Rx', visible: true },
  { id: 'corn-total-n', name: 'Total N Required' },
  { id: 'corn-om-contribution', name: 'OM Contribution' },
];

export default function NrxMap() {
  return <RxGoogleMap layers={layers} />;
}
